import { SITE, waLink, WA_DEFAULT_MESSAGE, track } from "@/constants/site";

const LINKS = [
  { label: "Soluções", href: "#solucoes" },
  { label: "Produtos", href: "#produtos" },
  { label: "Serviços", href: "#servicos" },
  { label: "Empresa", href: "#empresa" },
  { label: "Segmentos", href: "#segmentos" },
  { label: "Contato", href: "#contato" },
];

const SERVICES = [
  "Manutenção de motores elétricos",
  "Rebobinamento",
  "Motores recondicionados",
  "Bombas e motobombas",
  "Redutores e motoredutores",
  "Automação industrial",
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#top" className="flex items-center gap-3" aria-label="Power Motores Elétricos">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-xl" aria-hidden="true" />
              </span>
              <span className="leading-none">
                <span className="block font-heading text-lg font-extrabold tracking-tight text-background-50">
                  POWER
                </span>
                <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-background-100/70">
                  Motores Elétricos
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
              Energia que move a produção. Soluções em motores elétricos e equipamentos
              industriais para empresas que não podem parar.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">
              Navegação
            </h4>
            <ul className="mt-4 space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-background-100/70 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">
              Serviços
            </h4>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s}>
                  <a
                    href="#servicos"
                    className="text-sm text-background-100/70 transition-colors hover:text-background-50"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-50">
              Contato
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={waLink(WA_DEFAULT_MESSAGE)}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => track("whatsapp_click")}
                  className="flex items-center gap-2 text-sm text-background-100/70 transition-colors hover:text-background-50"
                >
                  <i className="ri-whatsapp-line text-lg text-[#25D366]" aria-hidden="true" />
                  {SITE.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={SITE.phoneHref}
                  onClick={() => track("phone_click")}
                  className="flex items-center gap-2 text-sm text-background-100/70 transition-colors hover:text-background-50"
                >
                  <i className="ri-phone-line text-lg" aria-hidden="true" />
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  className="flex items-center gap-2 text-sm text-background-100/70 transition-colors hover:text-background-50"
                >
                  <i className="ri-mail-line text-lg" aria-hidden="true" />
                  {SITE.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-sm text-background-100/60">
            © {new Date().getFullYear()} Power Motores Elétricos. Todos os direitos reservados.
          </p>
          <p className="text-sm text-background-100/60">
            Atendimento industrial no Sul, Sudeste e Centro-Oeste.
          </p>
        </div>
      </div>
    </footer>
  );
}